<template>
  <v-dialog v-model="alterDateModal" max-width="600px">
    <span class="link" slot="activator">
       <slot></slot>
     </span>
    <v-card>
      <v-card-title>
        <v-flex>
          <span class="mt-2 mb-2 headline">Atenção</span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right">
          <v-btn class="ma-0" icon @click.native="alterDateModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <p style="font-size:16px;">Insira um motivo para a alteração da data</p>
        <v-radio-group v-model="reason" :mandatory="false" row pa-3>
          <v-radio v-for="reason in reasons" color="red" :label="reason.description" :key="reason.id"  :value="reason.id"></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="blue--text darken-1" flat="flat" @click.native="alterSchedule">Sim, desejo alterar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'alter-date-warning',
  data () {
    return {
      reason: null
    }
  },
  methods: {
    alterSchedule () {
      if (this.reason === null) {
        this.$store.commit('toastr', {
          color: 'warning',
          texto: 'Insira um motivo'
        })
      } else {
        this.$store.dispatch('alterSchedule', this.reason)
      }
    }
  },
  computed: {
    reasons () {
      return this.$store.getters.reasons
    },
    alterDateModal: {
      get () {
        return this.$store.getters.alterDateModal
      },
      set (value) {
        this.$store.commit('toggleAlterDateModal', value)
      }
    }
  },
  mounted () {
    this.reason = this.$store.getters.selectedSchedule.idReason
    this.$store.dispatch('getReasons')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// AlterDateWarning.vue?6490a5b0